import { Component, OnInit, Output } from '@angular/core';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {

  @Output() confirmationResult = new EventEmitter<boolean>();
  constructor(private popoverRef: PopoverRef<any>) { }

  ngOnInit(): void {
  }

  close(){
    this.confirmationResult.emit(false);
    this.popoverRef.close();
  }

  yesClicked(){
    this.confirmationResult.emit(true);
    this.close();
  }

  noClicked(){
    this.confirmationResult.emit(false);
    this.close();
  }
}
